import React, { useState } from "react";
import { Button, Input, message, Form, Row, Col } from "antd";
import Service from "../service";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { MailOutlined, ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import AuthBrandingSection from "../components/Login/AuthBrandingSection";
import SecurityBadge from "../components/Login/SecurityBadge";

const ForgetPassword = () => {
  const { companyslug } = useParams();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      let payload = { ...values, companyslug: companyslug };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.hrmsforgotpaassword,
        body: payload,
      });
      if (response?.data?.status === 403) {
        message.error(response?.data?.message);
      } else if (response?.status === 200) {
        message.success(response?.data?.message);
      } else {
        message.error(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-login-page-wrapper">
      <Row className="login-container-row">
        {/* Left Side - Branding Section (same as login) */}
        <Col xs={24} lg={14} className="login-branding-section">
          <AuthBrandingSection />
        </Col>

        {/* Right Side - Form Section */}
        <Col xs={24} lg={10} className="login-form-section">
          <div className="form-content">
            <div className="form-card">
              <Form
                name="basic"
                layout="vertical"
                onFinish={handleSubmit}
                className="login-form-wrapper"
              >
                <div className="form-header">
                  <h2>Forgot password?</h2>
                  <p>Enter your email and we'll send you a reset link</p>
                </div>

                <div className="form-fields">
                  <div className="field-group">
                    <label>Email address</label>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          type: "email",
                          message: "The input is not valid E-mail!",
                        },
                        {
                          required: true,
                          message: "Please input your E-mail!",
                        },
                      ]}
                    >
                      <Input
                        type="email"
                        size="large"
                        placeholder="Enter your email"
                        prefix={<MailOutlined className="input-icon" />}
                      />
                    </Form.Item>
                  </div>
                </div>

                <div className="form-actions">
                  <Form.Item noStyle>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="btn-signin"
                      loading={loading}
                      disabled={loading}
                    >
                      Send Reset Link <ArrowRightOutlined />
                    </Button>
                  </Form.Item>
                </div>

                <div className="back-to-signin">
                  <Link to={companyslug ? `/${companyslug}/signin` : `/signin`}>
                    <ArrowLeftOutlined /> Back to Sign In
                  </Link>
                </div>
              </Form>
            </div>

            <SecurityBadge />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgetPassword;
